export default class SettingsMenuItem {
  onClickCallback = () => {}
  label = ""
  menuType = ""
  constructor(options = {}) {
    this.onClickCallback = options.onClickCallback;
    this.label = options.label;
    this.menuType = options.menuType;
    this._el = document.createElement('li');
    this.build();
  }

  build() {
    this.el().setAttribute('role', 'menuitem');
    this.el().setAttribute('data-submenu', this.label.split(" ").join("-").toLowerCase());
    this.el().className = `vjs-settings-button__menu__list-item`;
    this.el().onclick = () => {
      this.handleClick();
    }

    const text = document.createElement("span");
    text.textContent = this.label;
    this.el().appendChild(text);

    if (this.menuType === "checked") {
      const check = document.createElement("div");
      check.className = `check`;
      this.el().appendChild(check);
      this.el().setAttribute("data-active","true")
    } else if (this.menuType === "arrow") {
      const arrow = document.createElement("div");
      arrow.className = `arrow`;
      this.el().appendChild(arrow);
    } else {
      this.el().setAttribute("data-active","false")
    }
    

    return this.el();
  }

  el() {
    return this._el;
  }

  handleClick() {
    this.onClickCallback();
  }

}